import { Yii } from 'libraries/interfaces/Yii';
import { ILabels } from 'libraries/interfaces/ILabels';

export const MAIN_LABELS: ILabels = {
    title: Yii.t("wui-shared-js", "Dossier"),
    whenToIssue: Yii.t("wui-shared-js", "Émission prévue le %placeholder%"),
    whenIssued: Yii.t("wui-shared-js", "Émis le %placeholder%"),
    noPenaltyUntil: Yii.t("wui-shared-js", "Annulation gratuite jusqu'au %placeholder%"),
    validUntil: Yii.t("wui-shared-js", "Prix valide jusqu'au %placeholder%"),
    midOfficeReference: Yii.t("wui-shared-js", "Référence interne"),
    undefined: Yii.t("wui-shared-js", "Non définie"),
    undefinedCancellationDate: Yii.t("wui-shared-js", "Date d'annulation sans frais indisponible"),
    undefinedPriceValidityDate: Yii.t("wui-shared-js", "Date de validité du prix indisponible"),
    undefinedPrice: Yii.t("wui-shared-js", "Prix indisponible"),
    qualityCheckBooking: Yii.t("wui-shared-js", "Vérifier le dossier"),
    issueBooking: Yii.t("wui-shared-js", "Émettre le dossier"),
    cancelBooking: Yii.t("wui-shared-js", "Annuler le dossier"),
    voidBooking: Yii.t("wui-sasha-js", "Voider le dossier"),
    internal: Yii.t("wui-shared-js", "Statut Mid-Office  "),
    issuance: Yii.t("wui-shared-js", "Statut d'émission  "),
    statutDossier: Yii.t("wui-shared-js", "Statut du dossier  "),
    price: Yii.t("wui-shared-js", "Prix"),
    totalCost: Yii.t("wui-shared-js", "Total des tarifications :"),
    totalRetail: Yii.t("wui-shared-js", "Total prix de vente :"),
    totalPending: Yii.t("wui-shared-js", "Valeur restante des billets :"),
    totalUsed: Yii.t("wui-shared-js", "Valeur consommée des billets :"),
    totalIssued: Yii.t("wui-shared-js", "Total des billets émis :"),
    update: Yii.t("wui-shared-js", "Actualiser le dossier"),
    getBookingVoucher: Yii.t("wui-shared-js", "Obtenir le voucher"),
    getItineraryInText: Yii.t("wui-shared-js", "Exporter l'itinéraire au format texte"),
    modifyItinerary: Yii.t("wui-shared-js", "Enrichir l'itinéraire"),
    paymentStatus: Yii.t("wui-shared-js", "Statut paiement :"),
    dueValue: Yii.t('wui-shared-js', 'Solde:'),
    totalExpectedValue: Yii.t('wui-shared-js', 'Total:'),
    qualityCheck: Yii.t("wui-shared-js", "Statut Contrôle Qualité  "),
    qualityCheckStatusOk: Yii.t("wui-shared-js", "OK"),
    qualityCheckStatusAnomalies: Yii.t("wui-shared-js", "Anomalies"),
    addServices: Yii.t("wui-shared-js", "Ajouter des services annexes"),
    carbonFootprint: Yii.t("wui-shared-js", "Empreinte carbone :"),
    notDefined: Yii.t('wui-shared-js', 'Non défini'),
};

